import { Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import styles from './HeroContent.module.scss';

type Props = {
  className?: string;
  children?: React.ReactNode;
};

export const HeroContent: FC<Props> = (props) => {
  const { children } = props;
  const isMobile = useIsMobile();
  return (
    <Space
      direction={isMobile ? 'vertical' : 'horizontal'}
      className={styles.heroContent}
      size={24}
      align="center"
    >
      {children}
    </Space>
  );
};
